<template>

    <div class="inline-registration-page content-page fluid-container">
        <pulte-banner class="mt-3" title="GETTING STARTED"></pulte-banner>

        <div class="row pt-0 pt-md-2 pb-5">
            <div id="navigation-tree" class="mb-1 d-none d-md-block col-6 col-md-5 col-lg-4 offset-xl-2 col-xl-2">
                <h4 class="d-none d-md-block">Loan Application:</h4> <div data-v-32f25399="" id="navigation-tree-links">
                    <a class="" id="YourNewHome" active-class="router-link-active">
                        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="home" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-home fa-w-18 fa-fw"><path data-v-32f25399="" fill="currentColor" d="M570.24 247.41L512 199.52V104a8 8 0 0 0-8-8h-32a8 8 0 0 0-7.95 7.88v56.22L323.87 45a56.06 56.06 0 0 0-71.74 0L5.76 247.41a16 16 0 0 0-2 22.54L14 282.25a16 16 0 0 0 22.53 2L64 261.69V448a32.09 32.09 0 0 0 32 32h128a32.09 32.09 0 0 0 32-32V344h64v104a32.09 32.09 0 0 0 32 32h128a32.07 32.07 0 0 0 32-31.76V261.67l27.53 22.62a16 16 0 0 0 22.53-2L572.29 270a16 16 0 0 0-2.05-22.59zM463.85 432H368V328a32.09 32.09 0 0 0-32-32h-96a32.09 32.09 0 0 0-32 32v104h-96V222.27L288 77.65l176 144.56z" class=""></path></svg>
                        Your Home
                    </a>
                    <a id="Borrower" active-class="" class="">
                        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="user" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-user fa-w-14 fa-fw"><path data-v-32f25399="" fill="currentColor" d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z" class=""></path></svg>
                        Borrower
                    </a>
                    <a id="AdditionalBorrower" active-class="" class="">
                        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="user-friends" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class="svg-inline--fa fa-user-friends fa-w-20 fa-fw"><path data-v-32f25399="" fill="currentColor" d="M480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm0-144c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM272.1 276c-11.9 0-23.9 1.7-35.5 5.3-14.2 4.3-29.1 6.7-44.7 6.7s-30.5-2.4-44.7-6.7c-11.6-3.5-23.6-5.3-35.5-5.3-36.3 0-71.6 16.2-92.3 46.9C7.2 341.3 0 363.4 0 387.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM336 432H48v-44.8c0-28.9 18.4-53.6 44.1-63.1 10.3-3.8 21.6-3.7 31.9 0 22.1 7.9 45 11.9 68 11.9s45.8-4 68.1-11.9c10.3-3.7 21.6-3.8 31.9 0 25.7 9.4 44.1 34.2 44.1 63.1V432zM192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm0-176c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm431.7 237.1C606.4 291.5 577 278 546.8 278c-27.8 0-34.8 10-66.8 10s-39-10-66.8-10c-13.3 0-26.2 3-38.2 8.1 5.8 5.9 11.3 12 16 18.9 4.7 7 8.6 14.4 12 22 3.3-.7 6.7-1.1 10.2-1.1 17.2 0 29.6 10 66.8 10 37.4 0 49.5-10 66.8-10 15.7 0 29.5 6.7 37.1 17.9 5.3 7.9 8.1 17.1 8.1 26.7V400H416v32c0 5.5-.6 10.8-1.6 16H600c22.1 0 40-17.9 40-40v-37.3c0-19.9-6-38.3-16.3-53.6z" class=""></path></svg>
                        Additional Borrower
                    </a>
                    <a id="Declarations" active-class="router-link-active" class="">
                        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="file-contract" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="svg-inline--fa fa-file-contract fa-w-12 fa-fw"><path data-v-32f25399="" fill="currentColor" d="M196.66 363.33l-13.88-41.62c-3.28-9.81-12.44-16.41-22.78-16.41s-19.5 6.59-22.78 16.41L119 376.36c-1.5 4.58-5.78 7.64-10.59 7.64H96c-8.84 0-16 7.16-16 16s7.16 16 16 16h12.41c18.62 0 35.09-11.88 40.97-29.53L160 354.58l16.81 50.48a15.994 15.994 0 0 0 14.06 10.89c.38.03.75.05 1.12.05 6.03 0 11.59-3.41 14.31-8.86l7.66-15.33c2.78-5.59 7.94-6.19 10.03-6.19s7.25.59 10.19 6.53c7.38 14.7 22.19 23.84 38.62 23.84H288c8.84 0 16-7.16 16-16s-7.16-16-16-16h-15.19c-4.28 0-8.12-2.38-10.16-6.5-11.93-23.85-46.24-30.33-65.99-14.16zM369.83 97.98L285.94 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h287.94c26.5 0 48.07-21.5 48.07-47.99V131.97c0-12.69-5.17-24.99-14.17-33.99zM255.95 51.99l76.09 76.08h-76.09V51.99zM336 464.01H47.99V48.09h159.97v103.98c0 13.3 10.7 23.99 24 23.99H336v287.95zM88 112h80c4.42 0 8-3.58 8-8V88c0-4.42-3.58-8-8-8H88c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm0 64h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H88c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z" class=""></path></svg>
                        Declarations
                    </a>
                    <a data-v-32f25399="" id="WrappingUp" active-class="router-link-active" class="">
                        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="award" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-award fa-w-14 fa-fw"><path data-v-32f25399="" fill="currentColor" d="M446.34 433.21l-62.35-137.6c4.44-11.43 8.32-14.17 22.34-28.19a44.715 44.715 0 0 0 11.57-43.18c-8.29-30.95-8.3-26.65 0-57.62a44.721 44.721 0 0 0-11.57-43.18c-22.68-22.7-20.52-18.94-28.82-49.92a44.68 44.68 0 0 0-31.61-31.61c-30.96-8.29-27.22-6.13-49.9-28.81a44.714 44.714 0 0 0-43.19-11.58c-30.87 8.27-26.69 8.29-57.62 0A44.72 44.72 0 0 0 152 13.1c-22.66 22.66-18.93 20.51-49.9 28.81a44.68 44.68 0 0 0-31.61 31.61c-8.29 30.96-6.13 27.22-28.81 49.9-11.29 11.29-15.71 27.76-11.57 43.18 8.29 30.95 8.3 26.65 0 57.62a44.715 44.715 0 0 0 11.57 43.18c15.1 15.11 18.02 17.06 22.34 28.19L1.66 433.21c-5.96 13.15 4.85 27.44 20.45 27.44.29 0 .59-.01.88-.02l72.86-2.51 50.13 47.65C150.45 510 156.26 512 162 512c8.53 0 16.92-4.39 20.55-12.4L224 408.13l41.45 91.47c3.63 8.01 12.02 12.4 20.55 12.4 5.75 0 11.56-2 16.01-6.23l50.13-47.65 72.86 2.51c.3.01.59.02.88.02 15.6-.01 26.42-14.29 20.46-27.44zM153.73 446.9l-39.4-37.44-49.99 1.72 29.72-65.59c2.59 1.28 5.18 2.57 8.04 3.34 25.14 6.74 26.79 5.7 43.06 21.97 8.63 8.63 20.07 13.1 31.63 13.1 1.95 0 3.87-.55 5.81-.8l-28.87 63.7zm23.55-111.76c-22.02-22.08-33.74-24.8-60.92-32.09-11.34-42.3-17.04-45.88-39.4-68.24 11.51-42.93 7.89-49.38 0-78.79 30.96-30.96 31.22-37.69 39.41-68.24 29.09-7.78 37.07-8.22 68.25-39.4 42.62 11.42 49.19 7.94 78.79 0 21.29 21.29 25.65 27.98 68.24 39.4 11.34 42.3 17.04 45.88 39.4 68.25-11.33 42.3-8.19 48.26 0 78.81-21.29 21.29-27.98 25.66-39.4 68.25-26.27 7.04-38.28 9.44-60.93 32.09-31.14-18.18-67.02-15.45-93.44-.04zm176.51 75.01l-20.12-.69-39.4 37.44-28.87-63.7c1.94.26 3.86.8 5.81.8 11.55 0 23-4.47 31.63-13.1 16.41-16.41 17.81-15.2 43.06-21.97 2.85-.76 5.44-2.06 8.04-3.34l29.72 65.58-29.87-1.02zM320 192c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zm-96 48c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z" class=""></path></svg>
                        Wrapping Up
                    </a>
                    <div class="row mt-md-5 mt-2"><!----></div>
                </div>
            </div>
            <div class="row section-frame offset-1 col-10 offset-md-0 col-md-7 col-lg-8 col-xl-6 mt-3 mt-md-0">
                <div id="getting-started">
                    <loader-overlay :isLoading="isNavigating === true || isAuthenticationInitialized === false || checkingUserExists === true"></loader-overlay>
                    <div class="col-12">
                        <h5 v-if="isAuthenticated === true">Success!</h5>
                        <h5 v-else>Welcome</h5>

                        <h3 v-if="userExists === false && isAuthenticated === false">Let's get an account started for you.</h3>
                        <h4 v-if="userExists === true && isAuthenticated === false && emailAddress">We have detected a Pulte Mortgage account.</h4>
                        <h4 v-if="userExists === true && isAuthenticated === false && !emailAddress">Please enter your username and password below to log in.</h4>
                        <h4 v-if="isAuthenticated === true">You have been logged in successfully.</h4>

                        <p id="login-redirect" v-if="displayInlineLoginLink && isAuthenticated === false">Already have an account? <a href="#" class="router-link-exact-active router-link-active" @click="resetPageForLogin">Login here.</a></p>
                    </div>
                    <div id="registration" v-if="userExists === false && isAuthenticated === false">
                        <div class="col-sm-12 col-md-12 row mb-3">
                            <label class="col-12 pt-0 mt-0" for="first-name-input">
                                <strong>Confirm Legal First Name:</strong><span class="req-asx"></span>
                            </label>
                            <div class="col-10 col-sm-6 col-md-8 col-lg-5 col-xl-5">
                                <input id="first-name-input"
                                       type="text"
                                       v-bind:class="{'haserrors': hasErrors && !isFirstNameComplete || !isFirstNameValid, 'autopop' : !firstNameChanged}"
                                       v-model="firstName"
                                       class="form-control lo-sensitive"
                                       tabindex="1"
                                       @input="firstNameChanged = true" />
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12 row mb-3">
                            <label class="col-12 pt-0 mt-0" for="last-name-input">
                                <strong>Confirm Legal Last Name:</strong><span class="req-asx"></span>
                            </label>
                            <div class="col-10 col-sm-6 col-md-8 col-lg-5 col-xl-5">
                                <input id="last-name-input"
                                       type="text"
                                       v-bind:class="{'haserrors': hasErrors && !isLastNameComplete || !isLastNameValid, 'autopop' : !lastNameChanged}"
                                       v-model="lastName"
                                       class="form-control lo-sensitive"
                                       tabindex="2"
                                       @input="lastNameChanged = true" />
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12 row mb-3">
                            <label class="col-12 pt-0 mt-0" for="email-input">
                                <strong>Confirm Email Address:</strong><span class="req-asx"></span>
                            </label>
                            <div class="col-10 col-sm-6 col-md-8 col-lg-5 col-xl-5">
                                <input id="email-input"
                                       type="text"
                                       v-bind:class="{'haserrors': hasErrors && !isEmailComplete || !isEmailValid, 'autopop' : !emailChanged}"
                                       v-model="emailAddress"
                                       class="form-control lo-sensitive"
                                       tabindex="3"
                                       @input="emailChanged = true" />
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12 row mb-3">
                            <label class="col-12 pt-0 mt-0" for="password-input">
                                <strong>Select Your Password:</strong><span class="req-asx"></span>
                            </label>
                            <div class="col-10 col-sm-6 col-md-8 col-lg-5 col-xl-5">
                                <input :type="passwordType"
                                       class="form-control usrinput"
                                       id="password-input"
                                       v-model="password"
                                       placeholder="Password"
                                       tabindex="4">
                                <font-awesome-icon :icon="['far', 'eye']"
                                                   class="fainput "
                                                   fixed-width
                                                   @click="togglePassword"
                                                   v-if="passwordType === 'password'"
                                                   title="Show Password" />
                                <font-awesome-icon :icon="['far', 'eye-slash']"
                                                   class="fainput "
                                                   fixed-width
                                                   @click="togglePassword"
                                                   v-else
                                                   title="Hide Password" />
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12">
                            <password-requirements clss="col-7"
                                                   :value="password"
                                                   @all-requirements-met="setPasswordIsValid">
                            </password-requirements>
                        </div>
                        <div class="col-sm-12 col-md-12 row mb-3">
                            <label class="col-12 pt-0 mt-0" for="confirm-password-input">
                                <strong>Confirm Your Password:</strong><span class="req-asx"></span>
                            </label>
                            <div class="col-10 col-sm-6 col-md-8 col-lg-5 col-xl-5">
                                <input :type="confirmPasswordType"
                                       class="form-control usrinput"
                                       id="confirm-password-input"
                                       v-model="confirmPassword"
                                       placeholder="Password"
                                       tabindex="4">
                                <font-awesome-icon :icon="['far', 'eye']"
                                                   class="fainput "
                                                   fixed-width
                                                   @click="toggleConfirmPassword"
                                                   v-if="confirmPasswordType === 'password'"
                                                   title="Show Password" />
                                <font-awesome-icon :icon="['far', 'eye-slash']"
                                                   class="fainput "
                                                   fixed-width
                                                   @click="toggleConfirmPassword"
                                                   v-else
                                                   title="Hide Password" />
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12 row">
                            <label class="col-12 pt-0 mt-0" for="dob-input">
                                <strong>Date of Birth:</strong><span class="req-asx"></span>
                            </label>
                            <div class="col-10 col-sm-6 col-md-8 col-lg-5 col-xl-5">
                                <pulte-date-picker input-id="dob-input"
                                                   placeholder="Select Date"
                                                   v-model="dob"
                                                   tabindex="5"
                                                   :input-class="{'haserrors': hasErrors && !dobHasErrors}"
                                                   :disabledDates="disabledBirthDates"
                                                   :openDate="openDate" />
                                <span class="placeholder"></span>
                            </div>
                        </div>
                        <div>
                            <div class="col-1"></div>
                            <label class="col-8 checkbox-list-item form-check">
                                
                                    <input type="checkbox"
                                            name="yes-acceptPP"
                                            id="yes-acceptPP"
                                            :value="true"
                                            class="checkbox-input fa"
                                            v-model="privacyAccepted"
                                            v-on:keyup.enter="forceCheckFlip"
                                            v-on:keyup.space="forceCheckFlip"
                                            tabindex="7" ref="input"/>
                                    <span class="fake-box" 
                                            role="checkbox" 
                                            tabindex="6" 
                                            ref="fakeBox"
                                            v-on:keyup.enter="forceCheckFlip"
                                            v-on:keyup.space="forceCheckFlip"
                                            v-on:keydown="fixSpace($event)"></span>
                                    <span class="checkbox-label">
                                        I have read and agree to the <nav-link target="_blank"
                                                                                href="http://secure.pultemortgage.com/Content/PDF/PulteMortgage-Privacy-Notice.pdf" tabindex="7">Privacy Policy</nav-link> of this website
                                    </span>
                            </label>   
                        </div>
                        <div class="col-12 mt-3">
                            <button class="btn btn-primary pmbtn"
                                    @click="navigateNext"
                                    v-bind:disabled="requiredFieldsCompleted === false || isNavigating === true"
                                    tabindex="7">
                                Next
                            </button>
                        </div>
                        <div class="col-12 col-sm-8 mt-3">
                            <form-result-message :message="errorMessage"
                                                 :upperCase="false"
                                                 :error="hasErrors"></form-result-message>
                        </div>
                    </div>
                    <div id="loginRequired" v-if="userExists === true || isAuthenticated === true">
                        <div v-if="isAuthenticated === false">
                            <div class="col-12 col-xl-9 mt-3">
                                <login-form ref="loginForm" :displayRegisterNow="false"
                                            :username="emailAddress"
                                            :redirect-uri="redirectTarget"
                                            login-label="Next"
                                            :allow-inactive-accounts="true"
                                            :align-help-links-left="true">
                                    <template v-slot:username>
                                        <label for="username" class="pt-0 mt-0"><strong>Username:</strong> <span class="required">*</span></label>
                                    </template>
                                    <template v-slot:password>
                                        <label for="password" class="pt-0 mt-0"><strong>Password:</strong> <span class="required">*</span></label>
                                    </template>
                                </login-form>
                            </div>
                        </div>
                        <div v-if="isAuthenticated === true">
                            <div class="col-12 col-xl-9 mt-3">
                                <button class="btn btn-primary pmbtn"
                                        @click="navigateNext"
                                        v-bind:disabled="isNavigating === true"
                                        tabindex="8">
                                    Proceed to Application
                                </button>
                            </div>
                            <div class="col-12 col-sm-8 mt-3">
                                <form-result-message :message="errorMessage"
                                                     :upperCase="false"
                                                     :error="hasErrors"></form-result-message>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    import FormResultMessage from '../components/forms/FormResultMessage.vue';
    import PulteDatePicker from '../components/forms/PulteDatepicker';
    import PasswordRequirements from '../components/PasswordRequirements.vue';

    import { mapActions, mapGetters } from 'vuex';

    import moment from 'moment';

    const EMAIL_ADDRESS_FORMAT_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

    const createAxiosInstance = (baseUri, accessToken = null, contentType = 'application/json', responseType = 'text') => {
        let headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': contentType
        };
        if (accessToken !== null) {
            headers.Authorization = `Bearer ${accessToken}`;
        }
        return axios.create({
            baseURL: baseUri,
            headers: headers,
            responseType: responseType
        });
    };

    export default {
        name: 'getting-started',
        analyticsCategory: 'Getting Started Section',
        data() {
            return {
                inviteId: null,
                purchaseType: null,
                firstName: null,
                lastName: null,
                emailAddress: null,
                confirmEmailAddress: null,
                contactMethods: null,
                marketingPreference: null,

                errors: [],
                password: '',
                confirmPassword: '',
                dob: '',
                passwordIsValid: false,
                firstNameChanged: false,
                lastNameChanged: false,
                emailChanged: false,
                passwordType: 'password',
                confirmPasswordType: 'password',
                isNavigating: false,
                privacyAccepted: false,
                isEighteenYearsOld: false,

                userExists: null,
                checkingUserExists: true,
                isCreatingQuestionnaire: false,
                displayInlineLoginLink: false,
            }
        },
        components: {
            'form-result-message': FormResultMessage,
            'password-requirements': PasswordRequirements,
            'pulte-date-picker': PulteDatePicker,
        },
        mounted() {
            if (this.$route.query.invite) {
                try {
                    this.invite = this.$route.query.invite;
                    let uriDecodedInvite = decodeURIComponent(this.$route.query.invite);
                    let base64DecodedInvite = atob(uriDecodedInvite);
                    let parsedInvite = JSON.parse(base64DecodedInvite);
                    this.inviteId = parsedInvite.inviteId;
                    this.firstName = parsedInvite.firstName;
                    this.lastName = parsedInvite.lastName;
                    this.emailAddress = parsedInvite.emailAddress;
                    this.purchaseType = parsedInvite.purchaseType;
                } catch (parsingError) {
                    console.log(`app: registration: questionnaire: error parsing invite!`, parsingError);
                }
            } else {
                // todo:  how do we want to handle when the registration page is hit w/ out an invite?

            }

            if (this.emailAddress) {
                this.checkIfUserExists().then(() => {
                    if (this.userExists === true && this.isAuthenticated === true) {
                        return this.navigateNext();
                    }
                });
            }
            else {
                this.displayInlineLoginLink = true;
                this.checkingUserExists = false;
                this.userExists = false;
            }

        },
        computed: {
            ...mapGetters(['isAuthenticationInitialized', 'isAuthenticated', 'userProfile', 'accessToken']),
            firstNameFromToken() {
                if (this.isAuthenticated && this.userProfile) {
                    return this.userProfile["first_name"];
                }
                return null;
            },
            authenticatedFirstName() {
                return this.firstNameFromToken || 'not set';
            },
            lastNameFromToken() {
                if (this.isAuthenticated && this.userProfile) {
                    return this.userProfile["last_name"];
                }
                return null;
            },
            authenticatedLastName() {
                return this.lastNameFromToken || 'not set';
            },
            dobFromToken() {
                if (this.isAuthenticated && this.userProfile) {
                    return this.userProfile["date_of_birth"];
                }
                return null;
            },
            authenticatedDob() {
                return this.dobFromToken || 'not set';
            },
            hasErrors() {
                return this.errors.length > 0;
            },
            errorMessage() {
                return this.errors.map(({ message }) => message).join('<br/>');
            },
            isFirstNameValid() {
                return /^[a-zA-Z-' ]+$/.test(this.firstName);
            },
            isFirstNameComplete() {
                return this.firstName !== ''
                    && this.firstName.length > 1;
            },
            isLastNameValid() {
                return /^[a-zA-Z-' ]+$/.test(this.lastName);
            },
            isLastNameComplete() {
                return this.lastName !== ''
                    && this.lastName.length > 1;
            },
            isEmailValid() {
                return EMAIL_ADDRESS_FORMAT_REGEX.test(this.emailAddress);
            },
            isEmailComplete() {
                return this.emailAddress !== ''
                    && this.emailAddress.length > 0;
            },
            isConfirmPasswordValid() {
                return this.password !== this.confirmPassword ? false : true;
            },
            isDobValid() {
                var today = new moment();
                if (this.dob.length < 10)
                    return false;

                var date = moment(this.dob, 'MM/DD/YYYY');
                if (!date.isValid() || today.diff(date, 'years', false) > 125) {
                    this.isEighteenYearsOld = true;
                    return false;
                }
                else {
                    var diff = today.diff(date, 'years', false);
                    if (diff < 18) {
                        this.isEighteenYearsOld = false;
                        return false;
                    }
                }

                this.isEighteenYearsOld = true;
                return true;
            },
            isDobComplete() {
                return this.dob !== null
                    && this.dob.length > 0;
            },
            dobHasErrors() {
                return !this.isDobValid && this.isDobComplete;
            },
            disabledBirthDates() {
                // This object is used by vuejs-datepicker to gray out certain dates.
                // We will never have a borrower younger than 18, or older than 125 (probably).
                return {
                    from: new moment().subtract(18, 'years').toDate(),
                    to: new moment().subtract(125, 'years').subtract(1, 'day').toDate(),
                }
            },
            openDate() {
                return this.disabledBirthDates.from;
            },
            requiredFieldsCompleted() {
                let result = this.password !== null
                    && this.confirmPassword !== null
                    && this.password.length !== undefined
                    && this.password.length > 0
                    && this.passwordIsValid
                    && this.isDobComplete
                    && this.isEmailComplete
                    && this.isLastNameComplete
                    && this.isFirstNameComplete;
                return result;
            },
            redirectTarget() {
                if (typeof (window.location.href) === 'string') {
                    return window.location.href;
                }
                return window.location;
            }
        },
        methods: {
            ...mapActions(['loginSilent', 'initializeAuth']),
            forceCheckFlip() {
                this.$refs.input.click();
            },
            fixSpace($event) {  // hitting space to check is causing the page to scroll to bottom, prevent this
                if ($event.keyCode == 32 && ($event.target == document.body || $event.target === this.$refs.fakeBox)) {
                    $event.preventDefault();
                }
            },
            toggleFirstNameEdit() {
                this.canEditFirstName = !this.canEditFirstName;
            },
            togglePassword() {
                if (this.passwordType === 'password') {
                    this.passwordType = 'text';
                }
                else {
                    this.passwordType = 'password';
                }
            },
            toggleConfirmPassword() {
                if (this.confirmPasswordType === 'password') {
                    this.confirmPasswordType = 'text';
                }
                else {
                    this.confirmPasswordType = 'password';
                }
            },
            setPasswordIsValid(value) {
                this.passwordIsValid = value;
            },
            checkIfUserExists() {
                let axiosInstance = createAxiosInstance(this.$config['identityApiBaseUrl']);
                console.log(`app: api: checking if user exists`);
                return axiosInstance.get(`/api/identity/exists?emailAddress=${this.emailAddress}`)
                    .then(userExistsResponse => {
                        console.log(`app: api: user exists response`, userExistsResponse)
                        // responseType is 'text', so data arrives as the string 'true' or 'false'.
                        // Parse to a proper boolean so === true / === false checks work correctly.
                        const raw = userExistsResponse.data;
                        this.userExists = (raw === true || raw === 'true');
                    })
                    .catch(userExistsErr => {
                        console.log(`app: api: ERROR user exists response`, userExistsErr)
                    })
                    .finally(() => {
                        this.checkingUserExists = false;
                    });
            },
            resetPageForLogin() {
                this.displayInlineLoginLink = false;
                this.userExists = true;
            },
            navigateNext() {
                this.isNavigating = true;
                this.checkIfUserExists().then(() => {
                    if (this.userExists) {
                        this.displayInlineLoginLink = false;
                        this.isNavigating = false;
                    }
                    this.validateRegistration();
                });
            },
            validateRegistration() {
                this.errors = [];

                if (!this.isAuthenticated) {
                    if (!this.isFirstNameValid) {
                        this.errors.push({ message: 'Please provide your legal first name.', field: 'gettingStarted.firstName' });
                    }

                    if (!this.isLastNameValid) {
                        this.errors.push({ message: 'Please provide your legal last name.', field: 'gettingStarted.lastName' });
                    }

                    if (!this.isEmailValid) {
                        this.errors.push({ message: 'Please provide a valid email address.', field: 'gettingStarted.email' });
                    }

                    if (this.dobHasErrors) {
                        if (this.isEighteenYearsOld) {
                            this.errors.push({ message: 'Please provide your Date of Birth.', field: 'gettingStarted.dateOfBirth' });
                        }

                        if (!this.isEighteenYearsOld) {
                            this.errors.push({ message: 'You must be at least 18 years of age to register.', field: 'gettingStarted.dateOfBirth' });
                        }
                    }

                    if (!this.isConfirmPasswordValid) {
                        this.errors.push({ message: 'Your password and confirmation password don\'t match.', field: 'gettingStarted.confirmPassword' });
                    }
                    if (!this.privacyAccepted) {
                        this.errors.push({ message: 'Please acknowledge you have read and agree to our privacy policy.', field: 'gettingStarted.privacyAccepted' });
                    }
                }

                if (this.errors.length === 0) {
                    let registerIfRequiredPromise = () => Promise.resolve(true);
                    if (this.userExists === false && this.isAuthenticated === false) {
                        registerIfRequiredPromise = () => {
                            let registrationData = {
                                username: this.emailAddress,
                                password: this.password,
                                firstName: this.firstName,
                                middleInitial: '',
                                lastName: this.lastName,
                                dateOfBirth: new Date(this.dob),
                                registrationSource: 'InlineQuestionnaire'
                            };
                            let axiosInstance = createAxiosInstance(this.$config['identityApiBaseUrl']);
                            console.log(`app: api: registering user`);
                            return axiosInstance.post('/api/identity/registerAndLogin', registrationData)
                                .then(registrationResponse => {
                                    let responseData = registrationResponse.data;
                                    if (typeof responseData === 'string') {
                                        try {
                                            responseData = JSON.parse(responseData);
                                        } catch (parseErr) {
                                            // Keep original server text if response is not JSON.
                                        }
                                    }

                                    // user is registered, we need to log them in to conti
                                    if (registrationResponse && responseData && responseData.success === true) {
                                        // initialize the auth service if it's not alreadyue the questionnaire...
                                        console.log(`app: questionnaire: getting started: registration succeeded`, responseData);
                                        return true;
                                    } else {
                                        console.log(`app: registration: questionnaire: getting started: registration failed!`);
                                        if (responseData && responseData.isDuplicateEmail === true) {
                                            throw `${this.emailAddress} is already registered!`;
                                        } else {
                                            if (responseData && responseData.errors && responseData.errors.length && responseData.errors.length > 0) {
                                                throw responseData.errors.join('<br/>')
                                            } else {
                                                throw 'Unknown error registering!';
                                            }
                                        }
                                    }
                                })
                                .catch(registrationErr => {
                                    console.log(`app: registration: questionnaire: getting started: registration failed`, registrationErr);

                                    if (registrationErr && registrationErr.response && registrationErr.response.data) {
                                        let responseData = registrationErr.response.data;

                                        if (typeof responseData === 'string') {
                                            try {
                                                responseData = JSON.parse(responseData);
                                            } catch (parseErr) {
                                                // Keep original server text if response is not JSON.
                                            }
                                        }

                                        if (responseData && responseData.isDuplicateEmail === true) {
                                            throw `${this.emailAddress} is already registered!`;
                                        }

                                        if (responseData && responseData.errors && responseData.errors.length && responseData.errors.length > 0) {
                                            throw responseData.errors.join('<br/>');
                                        }

                                        if (typeof responseData === 'string' && responseData.length > 0) {
                                            throw responseData;
                                        }
                                    }

                                    throw registrationErr && registrationErr.message
                                        ? registrationErr.message
                                        : 'Unknown error registering!';
                                });
                        };
                    }

                    let loginIfRequiredPromise = () => Promise.resolve(true);
                    if (this.isAuthenticated === false) {
                        loginIfRequiredPromise = () => {
                            return this.loginSilent()
                                .then(result => {
                                    console.log(`app: registration: questionnaire: getting started: loginSilent (${result})`);
                                    // return the user id of the authenticated user
                                    if (this.accessToken) {
                                        return true;
                                    }
                                    throw 'User was logged in, but no access token was found';
                                }).catch(loginError => {
                                    console.log(`app: registration: questionnaire: getting started: loginSilent failed!`, loginError);
                                    // login_required means the IdP has no active session and silent auth cannot
                                    // succeed — redirect to the interactive login page with a ReturnUrl so the
                                    // user can authenticate and come back to complete registration.
                                    if (loginError && loginError.error === 'login_required') {
                                        const returnUrl = encodeURIComponent(window.location.href);
                                        window.location.href = `/login?ReturnUrl=${returnUrl}`;
                                        // Return a never-resolving promise so the downstream chain does not run
                                        return new Promise(() => {});
                                    }
                                    throw loginError;
                                });
                        };
                    }

                    let createQuestionnaireFromInvitePromise = () => {
                        let axiosInstance = createAxiosInstance(this.$config['questionnaireApiUrl'], this.accessToken);
                        let createInviteRequestData = {
                            inviteId: this.inviteId,
                            purchaseType: this.purchaseType,
                            firstName: this.firstName ? this.firstName : this.firstNameFromToken,
                            lastName: this.lastName ? this.lastName : this.lastNameFromToken,
                            dateOfBirth: this.dob ? this.dob : this.dobFromToken
                        };

                        const parseIfJsonString = (value) => {
                            if (typeof value !== 'string') {
                                return value;
                            }

                            try {
                                return JSON.parse(value);
                            } catch (error) {
                                return value;
                            }
                        };

                        const getQuestionnaireUrlFromResponse = (responseData) => {
                            const parsedData = parseIfJsonString(responseData);

                            let links = [];
                            if (parsedData && parsedData.links) {
                                links = parseIfJsonString(parsedData.links);
                            } else if (Array.isArray(parsedData)) {
                                links = parsedData;
                            } else if (parsedData && parsedData.rel) {
                                links = [parsedData];
                            }

                            if (!Array.isArray(links) || links.length === 0) {
                                return '';
                            }

                            for (let i = 0; i < links.length; i++) {
                                const link = parseIfJsonString(links[i]);
                                if (link && link.rel === 'QuestionnaireUrl' && link.href) {
                                    return link.href;
                                }
                            }

                            return '';
                        };

                        return axiosInstance
                            .post(`/api/questionnaires/fromInvite?api-version=1.0`, createInviteRequestData)
                            .then((createQuestionnaireResponse) => {
                                console.log(`app: decide: created questionnaire`, createQuestionnaireResponse.data);
                                if (createQuestionnaireResponse && createQuestionnaireResponse.data) {
                                    let destination = getQuestionnaireUrlFromResponse(createQuestionnaireResponse.data);
                                    if (destination) {
                                        return destination;
                                    }

                                    // Fallback for APIs that put the target url in the Location header.
                                    if (createQuestionnaireResponse.headers && createQuestionnaireResponse.headers.location) {
                                        return createQuestionnaireResponse.headers.location;
                                    }
                                }
                                throw 'Unable to create questionnaire!'
                            })
                            .catch(createQuestionnaireError => {
                                console.log('app: registration: questionnaire: error creating questionnaire', createQuestionnaireError);
                                throw createQuestionnaireError;
                            });
                    };

                    let navigateToQuestionnaire = (destination) => {
                        console.log(`app: registration: questionnaire: navigating to ${destination}`);
                        window.location = destination;
                    }

                    return registerIfRequiredPromise()
                        .then(loginIfRequiredPromise)
                        .then(createQuestionnaireFromInvitePromise)
                        .then(navigateToQuestionnaire)
                        .catch(chainError => {
                            console.log('app: registration: questionnaire: Unable to register, login, or create questionnaire', chainError);

                            this.errors.push({ message: chainError });

                            this.isNavigating = false
                        })
                        .finally(() => {
                            // note: we don't want the form to be actionable again if the navigation to the questionnaire takes too long
                        });

                } else {
                    this.isNavigating = false;
                }
            }
        },
        watch: {
            isAuthenticated: {
                handler(value) {
                    if (!this.dob) {
                        this.dob = dobFromToken;
                    };
                    if (!this.firstName) {
                        this.firstName = firstNameFromToken;
                    };
                    if (!this.lastName) {
                        this.lastName = lastNameFromToken;
                    };
                }
            },
            userExists: {
                handler(value) {
                    window.scrollTo(window.pageXOffset, 0);
                }
            }
        }
    }

</script>

<style scoped lang="scss">
   .checkbox-list-item {
       padding-top: 10px;
        /* Don't display the actual checkbox */
        input
        {
            display: none;
            
        }

    /* The span after the actual checkbox will be styled as a square */
        input + .fake-box {
            display: inline-block;
            position: absolute;
            background-color: #ffffff;
            border: 1px solid #c7c7c7;
            padding: 10px;
            border-radius: 3px;
            margin-top: 1px;
        }

        /* When the actual checkbox is checked, the span will be filled in */
        input:checked + .fake-box {
            background-color: #088354;
            border: 1px solid #088354;
            /* And a check mark will be displayed */
            &::after
            {
                content: "\f00c"; /* FontAwesome Unicode */
                font-family: FontAwesome !important;
                font-size: 18px;
                font-weight: 400;
                position: absolute;
                top: -3px;
                left: 1px;
                color: #ffffff;
            }

        }

        input + .fake-box:focus, input + .fake-box:active {
            outline: solid 2px #018181 !important;
        }

        /* Aligns the label horizontally */
        .checkbox-label {
            //padding-top: 10px;
            // margin-top: 10px;
            margin-right: 20px;
            margin-left: 30px;
        }
    }

    .inline-registration-page {
        scroll-behavior: smooth;
        h2

    {
        color: #00476b;
    }

    h3, h4 {
        display: block;
    }

    .faq-section h4 {
        color: #00476b;
    }

    .browser-recommendation-table {
        border-collapse: collapse;
        thead

    {
        background-color: #e7e7e7;
        th

    {
        color: #075a77;
    }

    }

    tbody td {
        border-bottom: 1px solid #075a77;
    }

    .platform {
        font-weight: bold;
        color: #075a77;
    }

    }

    span.req-asx:after {
        content: "*";
        color: red;
        font-weight: 400 !important;
    }

    .fainput {
        color: #075a77;
        float: right;
        margin-right: 6px;
        margin-top: -1.6em;
        position: relative;
        z-index: 2;
        cursor: pointer;
    }

    }

    #getting-started {
        h5

    {
        color: rgb(0,67,100);
    }

    #login-redirect {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .autopop {
        background-color: #D7F3DC;
        border: 1px solid #088354;
    }

        .autopop::-webkit-input-placeholder {
            border-style: solid;
            border-width: medium;
        }

        .autopop:-moz-placeholder {
            border-style: solid;
            border-width: medium;
        }

        .autopop:-ms-input-placeholder {
            border-style: solid;
            border-width: medium;
        }

    }

    #navigation-tree {
        max-width: 325px;
        min-width: 305px;
    }

    #navigation-tree {
        .error-msg

    {
        color: #d34428 !important;
    }

    h4 {
        padding-left: 10px !important;
        color: #004364 !important;
        font-weight: 900;
    }
    /*creating Active background sections */
    .sub-tree {
        background-color: #e7e7e7;
    }

    .router-link-active {
        background-color: #e7e7e7;
        color: #003C5B;
        margin-bottom: 0 !important;
    }

    .nav-tree-active {
        font-weight: bold !important;
    }


    #navigation-tree-links {
        position: relative;
        margin-left: 0px;
        /* All links */
        a

    {
        /* Are big, blocky, and linky */
        font-size: 1.5em;
        padding-left: 25px;
        display: block;
        position: relative;
        text-decoration: none;
        padding-top: 2px;
        padding-bottom: 5px;
    }

    /* Save button */
    .savingSize {
        font-size: 18px;
        font-weight: normal;
        border: 1px solid #018181;
        border-radius: 5px;
        width: fit-content;
        padding-right: 25px;
        padding-top: 5px;
        max-width: 190px;
    }


    /* Top level links */
    & > a {
        /* Are all green */
        color: #088354;
        /* And have (by default) a green circle with a checkmark */
        &::before

    {
        color: #088354;
        /*content: "✓";*/
        left: 2em;
        position: absolute;
        text-align: center;
        width: 1.5em;
        height: 1.5em;
    }

    /* The active top level link */
    &.router-link-active {
        /* Has no check mark */
        &::before

    {
        /*content: "";
          font-family:'Font Awesome 5 Pro'!important;
          font-size:12px;*/
    }

    /* And does have an arrow pointing to it */
    &::after {
        position: absolute;
        content: "";
        left: 14px;
        width: 0;
        height: 0;
        border-left: .4em solid teal;
        border-top: .4em solid transparent;
        border-bottom: .4em solid transparent;
        top: 7px;
    }


    /* The circles in front of links following the active one */
    & ~ a::before {
        /* Are empty and gray */
        /*content: "";*/
        background-color: #e7e7e7;
    }

    }
    }

    /* Subsections (second-level links) */
    & > .sub-tree {
        a

    {
        /* Are dark blue by default, reduced the font size, adjusted padding */
        color: #004364;
        padding-left: 68px;
        font-size: 18px;
        line-height: 1.2em;
        font-weight: 500;
        padding-bottom: 0.4em;
        background-image: url(../assets/nav-bullet-incompleted.png);
        background-repeat: no-repeat;
        background-position: 35px 4px;
    }

    a.routeCompletedClass {
        background-image: url(../assets/nav-check-completed.png);
    }

    a.routeHasErrorsClas {
        background-image: url(../assets//nav-X-error.png) !important;
    }
    /* The active second-level link is bold */
    .router-link-active {
        font-weight: bold;
        /* Second-level links after the active one are gray */
        & ~ a

    {
        color: #707070;
    }

    }
    }

    /* Subsections that don't immediately follow the active top-level link */
    & > a:not(.router-link-active) + .sub-tree {
        /* Are hidden */
        display: none;
    }

    }
    }
</style>
